import React from 'react'

const ChartsHeader = () => {
    return (
        <div>
            Charts Header
        </div>
    )
}

export default ChartsHeader
